import 'bootstrap';

import './components/animate';
import './components/menu';
import './components/our-wines';
import './components/gallery';